import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import apiClient from '../../../../services/api';
import store from '../../../../store';
import { toggleMessageOpen } from '../../../../store/actions/Message';

import ProjectPublicPreviewV1 from './ProjectPublicPreviewV1';
import ProjectPublicPreviewV2 from './ProjectPublicPreviewV2';

import { setSelectedProject } from '../../../../store/actions/Project';
import { setBackgrounds } from '../../../../store/actions/Backgrounds';
import { isMobile } from 'react-device-detect';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Cancel, Save, WarningAmber } from '@mui/icons-material';

function ProjectPublicPreview() {
    const { t } = useTranslation();
    const [projectData, setProjectData] = useState(null);
    const [elements, setElements] = useState([]);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [aborted, setAborted] = React.useState(false);

    useEffect(() => {
        const urlParams = window.location.href.split('/');
        let token = urlParams.at(-1);

        apiClient.post('/api/projects/load-public', { token: token }).then(response => {
            if (!response.data.success) {
                return;
            }

            setProjectData(response.data);
            setElements(response.data.project_elements);
            store.dispatch(setSelectedProject(response.data));

            if (response?.data?.backgrounds) {
                const backgroundsData = response.data.backgrounds;
                delete response.data.backgrounds;
                store.dispatch(setBackgrounds(backgroundsData));
            }
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"));
        });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!projectData) return;
        if (isMobile) {
            const nrOfUniqueObjects = projectData?.model?.binaries?.length || 0;
            const nrOfTextures = projectData?.model?.textures?.length || 0;

            if (!projectData?.model?.gltf) {
                setDialogOpen(true);
            }

            if (nrOfUniqueObjects >= 300) {
                setDialogOpen(true);
            }

            if (nrOfUniqueObjects + nrOfTextures >= 2500) {
                setDialogOpen(true);
            }
        }
    }, [isMobile, projectData]);

    const handleCancel = () => {
        setDialogOpen(false);
        setAborted(true);
    };

    const handleContinue = () => {
        setDialogOpen(false);
    };

    const renderWarningDialog = () => {
        return (
            <Dialog open={dialogOpen}>
                <DialogTitle style={{ fontWeight: 'bold' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningAmber sx={{ color: '#facc15' }} />{t('Warning title')}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {t('Warning description')}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} startIcon={<Cancel />} color="error" variant="contained" size="small">
                        {t('Abort')}
                    </Button>
                    <Button onClick={handleContinue} startIcon={<Save />} color="success" variant="contained" size="small">
                        {t('Continue')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    if (dialogOpen && !aborted) {
        return renderWarningDialog();
    }

    if (!isMobile) {
        return projectData && (
            projectData.models && projectData.models.length != 0
                ? <ProjectPublicPreviewV2 data={projectData} projectElements={elements} />
                : <ProjectPublicPreviewV1 data={projectData} projectElements={elements} />
        );
    } else {
        return projectData && (
            projectData.model && projectData.model.gltf
                ? <ProjectPublicPreviewV1 data={projectData} projectElements={elements} abort={aborted} />
                : <ProjectPublicPreviewV2 data={projectData} projectElements={elements} abort={aborted} />
        )
    }
}

export default ProjectPublicPreview;

/*
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import apiClient from '../../../../services/api';
import store from '../../../../store';
import { toggleMessageOpen } from '../../../../store/actions/Message';

import ProjectPublicPreviewV1 from './ProjectPublicPreviewV1';
import ProjectPublicPreviewV2 from './ProjectPublicPreviewV2';

import { setSelectedProject } from '../../../../store/actions/Project';
import { setBackgrounds } from '../../../../store/actions/Backgrounds';

function ProjectPublicPreview() {
    const { t } = useTranslation();
    const [projectData, setProjectData] = useState(null);
    const [elements, setElements] = useState([]);
    
    useEffect(() => {
        const urlParams = window.location.href.split('/');
        let token = urlParams.at(-1);

        apiClient.post('/api/projects/load-public', {token: token}).then(response => {
            if(!response.data.success) {
                return;
            }

            setProjectData(response.data);
            setElements(response.data.project_elements);
            store.dispatch(setSelectedProject(response.data));
            
            if (response?.data?.backgrounds) {
                const backgroundsData = response.data.backgrounds;
                delete response.data.backgrounds;
                store.dispatch(setBackgrounds(backgroundsData));
            }
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"));
        });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

     const isHoppeDomain = typeof window !== "undefined" && window.location.hostname === "10029hoppeag-ebo.ebhit.de";

    if (isHoppeDomain) {
        return projectData && (
            projectData.model && projectData.model.gltf
            ? <ProjectPublicPreviewV1 data={projectData} projectElements={elements} />
            : <ProjectPublicPreviewV2 data={projectData} projectElements={elements} />
        );
    }

    return projectData && (
        projectData.models && projectData.models.length != 0
            ? <ProjectPublicPreviewV2 data={projectData} projectElements={elements} />
            : <ProjectPublicPreviewV1 data={projectData} projectElements={elements} />
    );
}

export default ProjectPublicPreview;
*/
